import ApiService from '../_helper/api.service';
import AdminApiResources from '../../constants/api/resources/wizard';
import FileService from '../_helper/file.service';

const TransactionService = {
  getTransactions(params: any) {
    return ApiService.get(AdminApiResources.transactions, { params: params });
  },

  downloadTransactionsCSV(data: any) {
    return ApiService.get(AdminApiResources.transactionsCSV, {
      headers: {
        Accept: 'text/csv; charset=utf-8',
        'Content-Type': 'text/csv; charset=utf-8',
      },
      params: data,
      responseType: 'text',
    }).then(res => {
      FileService.saveCSV(res.data, 'transactions.csv');
      return res;
    });
  },
};

export default TransactionService;
